<div id="qrCodeScannerContainer" class="scanner-container">
  <div #qrCodeScanner id="qrCodeScanner" class="scanner-box"></div>
  <button mat-stroked-button type="button" class="cancelButton" (click)="cancel()">
    {{ this.res.get('Cancel').toUpperCase() }}
  </button>
</div>
